const state = {
  enable: 0, // 是否启用
  url: ''
}

const mutations = {
  FRONTEND_PLUGIN_ENABLE: (state, data) => {
    console.log('enableFrontEndPlugin:', data)
    if (data.enable && data.url) {
      if (['prod'].includes(process.env.VUE_APP_ENV) && data.urlProd !== '0') {
        // 生产环境:根据登录域名 + /tenant/18182
        const prodUrl = document.location.toString().split('//')
        state.url = prodUrl[0] + '//' + prodUrl[1].split('/')[0] + data.urlProd
      } else { // 测试环境指定域名
        state.url = data.url
      }
      state.enable = data.enable
      console.log('frontEndPluginUrl:', state.url)
    }
  }
}

const actions = {
  setConfig({ commit }, entries) {
    commit('FRONTEND_PLUGIN_ENABLE', entries)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
